export interface IApiLocation {
  City?: string;
  State?: string;
  StateAbbr?: string;
  Country?: string;
}

export default class Location {
  city: string;
  state: string;
  stateAbbr: string;
  country: string;

  constructor() {
    this.city = '';
    this.state = '';
    this.stateAbbr = '';
    this.country = '';
  }

  static mappingObject(_obj: IApiLocation): Location {
    const obj = new Location();
    obj.city = _obj.City || '';
    obj.state = _obj.State || '';
    obj.stateAbbr = _obj.StateAbbr || '';
    obj.country = _obj.Country || '';

    return obj;
  }
}
